var _rawFetch = window.fetch;

/* ── Shared helpers ─────────────────────────────────────────────────────────
   liEsc       HTML-escape anything that came from a cart line or the builder.
   liIsBrief   True for a line added by the Lovable builder ("Custom quote
               request"). These are $0 quote lines: no units, no price.
   liBriefInfo Display fields for a brief line (title, sub, image).
   liCartError Turns a /cart/*.js response into a real error message, or null
               when it succeeded (status 422, "Cart Error", any 4xx-5xx).
   ──────────────────────────────────────────────────────────────────────── */
function liEsc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

function liIsBrief(props) {
  if (!props) return false;
  return props['Order type'] === 'Custom quote request' || !!props['Brief ID'];
}

/* Quote lines from an order section in quote mode (accessories with no set
   price write "Pricing: Quote on request"). Priced after review, so they
   never show or add $0.00. Builder briefs are quote lines too. */
function liIsQuote(props) {
  if (!props) return false;
  return liIsBrief(props) || String(props['Pricing'] || '').toLowerCase() === 'quote on request';
}

/* The hidden data div for the cart page. It used to share its id with the
   site-wide #li-cart-data div in layout/theme.liquid, which made two
   elements with one id on /cart. The cart section now uses #li-cart-meta;
   the old id stays as a fallback for a theme that still has it. */
function liCartMeta() {
  return document.getElementById('li-cart-meta') || document.getElementById('li-cart-data');
}

function liBriefInfo(props) {
  props = props || {};
  var product = props['Product'] || 'Custom';
  var n = parseInt(props['Designs'], 10) || 1;
  var img = props['_preview'] || '';
  if (img && img.indexOf('//') === 0) img = 'https:' + img;
  return {
    title: product + ' design brief',
    sub: n + ' design' + (n !== 1 ? 's' : '') + ', priced after review',
    img: img,
    designs: n,
    // Older briefs carry the bare domain, which has no SSL.
    link: String(props['Design link'] || '').replace(/^https?:\/\/luckyinger\.com\.au/i, 'https://www.luckyinger.com.au'),
    notes: props['Client notes'] || ''
  };
}

function liCartError(status, data) {
  data = data || {};
  var bad = status >= 400 || data.status === 422 ||
    (typeof data.status === 'number' && data.status >= 400) ||
    data.message === 'Cart Error';
  if (!bad) return null;
  return data.description || data.message || ('Cart error (' + status + ')');
}

function liReadCartJson(r) {
  return r.text().then(function (t) {
    var data = {};
    try { data = t ? JSON.parse(t) : {}; } catch (e) { data = { description: t }; }
    var err = liCartError(r.status, data);
    if (err) throw new Error(err);
    return data;
  });
}

/**
 * Lucky Inger: localStorage Order Store
 */

window.LIOrder = (function () {
  var KEY = 'li_order';

  function load() {
    try {
      var raw = localStorage.getItem(KEY) || sessionStorage.getItem(KEY);
      if (!raw) return { items: [] };
      var data = JSON.parse(raw);
      if (!localStorage.getItem(KEY) && sessionStorage.getItem(KEY)) {
        try { localStorage.setItem(KEY, raw); } catch(e) {}
      }
      return data;
    } catch (e) { return { items: [] }; }
  }

  function save(data) {
    try {
      var json = JSON.stringify(data);
      localStorage.setItem(KEY, json);
      sessionStorage.setItem(KEY, json);
      window.dispatchEvent(new CustomEvent('li:order:updated', { detail: data }));
      LIOrder.updateBadge();
    } catch (e) { console.error('LIOrder save error:', e); }
  }

  function uid() {
    return 'li-' + Math.random().toString(36).slice(2, 9) + '-' + Date.now();
  }

  var LIOrder = {
    get: function () { return load(); },
    items: function () { return load().items; },

    totalUnits: function () {
      return load().items.reduce(function (sum, item) {
        return sum + Object.values(item.sizes || {}).reduce(function (s, q) {
          return s + (parseInt(q) || 0);
        }, 0);
      }, 0);
    },

    count: function () { return load().items.length; },

    add: function (item) {
      var data = load();
      item.id = uid();
      item.addedAt = new Date().toISOString();
      data.items.push(item);
      save(data);
      return item.id;
    },

    remove: function (id) {
      var data = load();
      data.items = data.items.filter(function (i) { return i.id !== id; });
      save(data);
    },

    clear: function () {
      localStorage.removeItem(KEY);
      sessionStorage.removeItem(KEY);
      window.dispatchEvent(new CustomEvent('li:order:updated', { detail: { items: [] } }));
      LIOrder.updateBadge();
    },

    /* Header count = pieces: Shopify's item_count (cart quantities are the
       real unit counts) plus the pieces in saved builder lines. */
    updateBadge: function () {
      var liUnits = LIOrder.totalUnits();
      _rawFetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { LIOrder._applyBadge(liUnits + (cart.item_count || 0)); })
        .catch(function () { LIOrder._applyBadge(liUnits); });
    },

    _applyBadge: function (count) {
      var cartAnchor = document.getElementById('cart-icon-bubble') ||
                       document.querySelector('a[href="/cart"].header__icon--cart');
      var bubble = cartAnchor ? cartAnchor.querySelector('.cart-count-bubble') : null;
      if (count > 0) {
        if (!bubble && cartAnchor) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          cartAnchor.appendChild(bubble);
        }
        if (bubble) {
          // One number only. The header's desktop pill copies the first number
          // it finds in here, so the screen-reader text must not run into it
          // (that made "94" read as "9494").
          bubble.innerHTML = '<span aria-hidden="true"></span> <span class="visually-hidden"></span>';
          bubble.firstChild.textContent = count < 1000 ? String(count) : '999+';
          bubble.lastChild.textContent = count + ' piece' + (count !== 1 ? 's' : '') + ' in your order';
          bubble.style.display = '';
        }
      } else {
        if (bubble) bubble.style.display = 'none';
      }
      // Desktop header pill (sections/header.liquid, .li-util__cart).
      document.querySelectorAll('.li-util__cart').forEach(function (link) {
        var pill = link.querySelector('.li-cart-bubble');
        if (count > 0) {
          if (!pill) {
            pill = document.createElement('span');
            pill.className = 'li-cart-bubble';
            pill.setAttribute('aria-hidden', 'true');
            link.appendChild(pill);
          }
          pill.textContent = count < 1000 ? String(count) : '999+';
        } else if (pill) {
          pill.remove();
        }
        link.setAttribute('aria-label', count > 0 ? 'Cart, ' + count + ' piece' + (count !== 1 ? 's' : '') : 'Cart');
      });
    }
  };

  document.addEventListener('DOMContentLoaded', function () { LIOrder.updateBadge(); });

  return LIOrder;
})();


// ── LI Cart Popup Notification ────────────────────────────────────────────────
// One popup for every add: order sections, standard products and the builder.
// Primary action is "Review order" (/cart), never straight to /checkout, so
// the cart page's minimum checks and line sync always run before checkout.

(function () {
  var POPUP_ID = 'li-cart-popup';

  (function () {
    var s = document.createElement('style');
    s.id = 'li-cart-popup-styles';
    s.textContent = [
      /* Matches the cart page: dark card, yellow main button. Top right on desktop, full width on phones. */
      '#li-cart-popup {',
      '  position: fixed; top: 84px; right: 20px; z-index: 99999;',
      '  width: 360px; max-width: calc(100vw - 32px); box-sizing: border-box;',
      '  background: rgb(var(--color-background, 10 10 10)); color: rgb(var(--color-foreground, 243 243 243));',
      '  border: 1px solid rgba(var(--color-foreground, 243 243 243), 0.16); border-radius: 14px;',
      '  box-shadow: 0 16px 40px rgba(0,0,0,0.45);',
      '  padding: 14px; display: flex; gap: 12px; align-items: flex-start; font-family: var(--font-body-family);',
      '  opacity: 0; transform: translateY(-8px); transition: opacity 0.2s ease, transform 0.2s ease; pointer-events: none;',
      '}',
      'body.li-on-builder #li-cart-popup { top: 56px; }',
      '#li-cart-popup.li-popup--visible { opacity: 1; transform: translateY(0); pointer-events: auto; }',
      '#li-cart-popup .li-popup-img, #li-cart-popup .li-popup-img-ph { width: 60px; height: 60px; object-fit: cover; border-radius: 8px; flex-shrink: 0; background: rgba(var(--color-foreground, 243 243 243), 0.06); }',
      '#li-cart-popup .li-popup-body { flex: 1; min-width: 0; padding-right: 18px; }',
      '#li-cart-popup .li-popup-label { display: flex; align-items: center; gap: 6px; font-size: 10.5px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: #2fbf71; margin-bottom: 3px; }',
      '#li-cart-popup .li-popup-label::before { content: "\\2713"; font-size: 12px; letter-spacing: 0; }',
      '#li-cart-popup.li-popup--error .li-popup-label { color: #e5484d; }',
      '#li-cart-popup.li-popup--error .li-popup-label::before { content: "!"; }',
      '#li-cart-popup .li-popup-title { font-size: 15px; font-weight: 650; line-height: 1.3; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }',
      '#li-cart-popup .li-popup-sub { font-size: 12.5px; color: rgba(var(--color-foreground, 243 243 243), 0.62); line-height: 1.4; margin-top: 2px; }',
      '#li-cart-popup .li-popup-order { font-size: 12.5px; color: rgba(var(--color-foreground, 243 243 243), 0.62); margin-top: 6px; padding-top: 6px; border-top: 1px solid rgba(var(--color-foreground, 243 243 243), 0.12); }',
      '#li-cart-popup .li-popup-order:empty { display: none; }',
      '#li-cart-popup .li-popup-order strong { color: rgb(var(--color-foreground, 243 243 243)); }',
      '#li-cart-popup .li-popup-actions { display: flex; gap: 8px; margin-top: 10px; }',
      '#li-cart-popup .li-popup-btn { flex: 1; display: inline-flex; align-items: center; justify-content: center; min-height: 40px; padding: 0 12px; font-size: 13px; font-weight: 700; text-align: center; border-radius: 10px; cursor: pointer; text-decoration: none; border: 1px solid rgba(var(--color-foreground, 243 243 243), 0.22); background: transparent; color: rgb(var(--color-foreground, 243 243 243)); font-family: inherit; white-space: nowrap; }',
      '#li-cart-popup .li-popup-btn--primary { background: rgb(var(--color-button, 255 214 0)); color: #0a0a0a; border-color: transparent; }',
      '#li-cart-popup .li-popup-close { position: absolute; top: 8px; right: 8px; width: 28px; height: 28px; background: none; border: none; cursor: pointer; color: rgba(var(--color-foreground, 243 243 243), 0.5); font-size: 20px; line-height: 1; padding: 0; display: flex; align-items: center; justify-content: center; }',
      '@media (max-width: 749px) { #li-cart-popup { top: auto; bottom: calc(16px + env(safe-area-inset-bottom)); left: 16px; right: 16px; width: auto; max-width: none; transform: translateY(8px); } html:has(.lid-sticky-bar:not([hidden])) #li-cart-popup { bottom: calc(130px + env(safe-area-inset-bottom)); } }'
    ].join('\n');
    document.head.appendChild(s);
  })();

  function getPopup() {
    var el = document.getElementById(POPUP_ID);
    if (!el) {
      el = document.createElement('div');
      el.id = POPUP_ID;
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
      el.addEventListener('mouseenter', function () { clearTimeout(_hideTimer); });
      el.addEventListener('mouseleave', function () {
        if (!el.classList.contains('li-popup--sticky')) _hideTimer = setTimeout(hidePopup, 3000);
      });
      el.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-li-popup-close]') : null;
        if (b) { e.preventDefault(); hidePopup(); }
      });
    }
    return el;
  }

  var _hideTimer = null;

  /* opts: title, sub, imgSrc, label, error, sticky, stayLabel
     stayLabel is the secondary button ("Keep shopping" / "Keep designing"). */
  function showPopup(opts) {
    opts = opts || {};
    var el = getPopup();
    var imgHtml = opts.imgSrc
      ? '<img class="li-popup-img" src="' + liEsc(opts.imgSrc) + '" alt="">'
      : '<div class="li-popup-img-ph"></div>';
    var actions = opts.error
      ? '<button type="button" class="li-popup-btn" data-li-popup-close>Close</button>'
      : '<button type="button" class="li-popup-btn" data-li-popup-close>' + liEsc(opts.stayLabel || 'Keep shopping') + '</button>' +
        '<a href="/cart" target="_top" class="li-popup-btn li-popup-btn--primary">Review order</a>';
    el.innerHTML =
      '<button type="button" class="li-popup-close" aria-label="Close" data-li-popup-close>&times;</button>' +
      imgHtml +
      '<div class="li-popup-body">' +
        '<div class="li-popup-label">' + liEsc(opts.label || (opts.error ? 'Not added' : 'Added to your order')) + '</div>' +
        '<div class="li-popup-title">' + liEsc(opts.title || 'Item added') + '</div>' +
        '<div class="li-popup-sub">' + liEsc(opts.sub || '') + '</div>' +
        '<div class="li-popup-order" data-li-popup-order></div>' +
        '<div class="li-popup-actions">' + actions + '</div>' +
      '</div>';
    el.classList.toggle('li-popup--error', !!opts.error);
    el.classList.toggle('li-popup--sticky', !!(opts.sticky || opts.error));
    el.classList.remove('li-popup--visible');
    void el.offsetWidth;
    el.classList.add('li-popup--visible');
    if (window.LIOrder) window.LIOrder.updateBadge();
    clearTimeout(_hideTimer);
    if (!opts.sticky && !opts.error) _hideTimer = setTimeout(hidePopup, 6000);
    if (!opts.error) fillOrderLine(el);
  }

  /* "Your order: 302 pieces, 3 items" under the added item */
  function fillOrderLine(el) {
    if (!_nativeFetch) return;
    _nativeFetch.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var pieces = 0, lines = (cart.items || []).length;
      (cart.items || []).forEach(function (it) {
        var pr = it.properties || {};
        pieces += parseInt(String(pr['Total units'] || pr['Quantity'] || '').replace(/[^0-9]/g, ''), 10) || it.quantity || 0;
      });
      var box = el.querySelector('[data-li-popup-order]');
      if (box && lines) box.innerHTML = 'Your order: <strong>' + pieces + ' pieces</strong>, ' + lines + ' item' + (lines !== 1 ? 's' : '');
    }).catch(function () {});
  }

  function hidePopup() {
    var el = document.getElementById(POPUP_ID);
    if (el) el.classList.remove('li-popup--visible');
  }

  function onCartPage() { return window.location.pathname === '/cart'; }

  var _lastLICount = 0;
  document.addEventListener('DOMContentLoaded', function () {
    _lastLICount = window.LIOrder ? window.LIOrder.count() : 0;
  });

  window.addEventListener('li:order:updated', function (e) {
    var items = e.detail && e.detail.items ? e.detail.items : [];
    var newCount = items.length;
    if (newCount > _lastLICount && items.length > 0 && !onCartPage()) {
      var last = items[items.length - 1];
      var units = last.sizes
        ? Object.values(last.sizes).reduce(function (s, q) { return s + (parseInt(q) || 0); }, 0)
        : 0;
      var sub = (last.printMethod || '') +
        (last.colour ? ' - ' + last.colour : '') +
        (units ? ' - ' + units + ' units' : '');
      showPopup({
        title: last.productTitle || 'Order line added',
        sub: sub.replace(/^[ -]+/, ''),
        imgSrc: last.productImage || ''
      });
    }
    _lastLICount = newCount;
  });

  // Any /cart/add.js made through window.fetch (order sections, theme product
  // forms) gets the popup. The builder bridge uses _rawFetch and shows its own.
  var _nativeFetch = window.fetch;
  window.fetch = function (resource, init) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var isAddToCart = false;
    try {
      var parsed = new URL(url, window.location.origin);
      var p = parsed.pathname;
      isAddToCart = (p === '/cart/add' || p === '/cart/add.js');
    } catch (e) {
      isAddToCart = (url.indexOf('/cart/add.js') !== -1);
    }
    var promise = _nativeFetch.apply(this, arguments);
    var isCartWrite = isAddToCart || /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url);
    if (isCartWrite) {
      promise.then(function (response) {
        if (response && response.ok && window.LIOrder) setTimeout(function () { window.LIOrder.updateBadge(); }, 0);
      }).catch(function () {});
    }
    if (isAddToCart && !onCartPage() && !document.getElementById('lid-root')) {
      promise.then(function (response) {
        if (!response.ok) return response;
        var clone = response.clone();
        clone.json().then(function (data) {
          var item = data.items ? data.items[0] : data;
          if (!item) return;
          var props = item.properties || {};
          if (liIsBrief(props)) {
            var b = liBriefInfo(props);
            showPopup({ title: b.title, sub: b.sub, imgSrc: b.img, stayLabel: 'Keep designing' });
            return;
          }
          var imgSrc = props['_preview_image'] || (item.featured_image && item.featured_image.url
            ? item.featured_image.url : (item.image || ''));
          if (imgSrc && imgSrc.indexOf('//') === 0) imgSrc = 'https:' + imgSrc;
          var units = parseInt(props['Total units'] || props['Quantity'], 10) || item.quantity || 1;
          var sub = item.variant_title && item.variant_title !== 'Default Title'
            ? item.variant_title + ' - ' + units + ' units'
            : units + ' unit' + (units !== 1 ? 's' : '');
          showPopup({
            title: item.product_title || item.title || 'Item added',
            sub: sub,
            imgSrc: imgSrc
          });
        }).catch(function () {});
        return response;
      }).catch(function () {});
    }
    return promise;
  };

  /* Portal Digital print banner: swipe through the designs on the main photo.
     Thumbnails and arrows move it; the Order button follows the design on show. */
  function dtfGalGo(gal, i) {
    var track = gal.querySelector('[data-li-dtf-track]');
    if (!track) return;
    var n = track.children.length;
    i = Math.max(0, Math.min(n - 1, i));
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }
  function dtfGalSync(track) {
    var gal = track.closest('[data-li-dtf-gal]'), card = track.closest('.li-dtf-card');
    if (!gal || !card) return;
    var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)), slide = track.children[i];
    if (!slide || gal.__liI === i) return;
    gal.__liI = i;
    var name = slide.getAttribute('data-name') || '';
    var nm = gal.querySelector('[data-li-dtf-name]'); if (nm) nm.textContent = name;
    var ct = gal.querySelector('[data-li-dtf-count]'); if (ct) ct.textContent = (i + 1) + ' / ' + track.children.length;
    Array.prototype.forEach.call(card.querySelectorAll('[data-li-dtf-go]'), function (t) {
      t.classList.toggle('is-on', +t.getAttribute('data-li-dtf-go') === i);
    });
    var cta = card.querySelector('[data-li-dtf-cta]');
    if (cta) cta.setAttribute('href', slide.getAttribute('href'));
  }
  function dtfMarkNew() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-li-dtf-gal][data-li-dtf-url]'), function (gal) {
      if (gal.__liNew) return; gal.__liNew = true;
      var card = gal.closest('.li-dtf-card'); if (!card || !window.fetch) return;
      fetch(gal.getAttribute('data-li-dtf-url').split('?')[0] + '.json', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var pr = data && data.product; if (!pr || !pr.variants) return;
          var di = -1;
          (pr.options || []).forEach(function (o, i) { if (/design/i.test(o.name || '')) di = i; });
          if (di < 0) return;
          var born = {}, oldest = Infinity;
          pr.variants.forEach(function (v) {
            var t = Date.parse(v.created_at), dn = v['option' + (di + 1)];
            if (!isFinite(t) || !dn) return;
            if (t < oldest) oldest = t;
            if (born[dn] == null || t < born[dn]) born[dn] = t;
          });
          Object.keys(born).forEach(function (dn) {
            if (!(Date.now() - born[dn] < 45 * 864e5 && born[dn] - oldest > 7 * 864e5)) return;
            Array.prototype.forEach.call(card.querySelectorAll('.li-dtf-card__thumb[title], .li-dtf-gal__slide[data-name]'), function (el) {
              var nm = el.getAttribute('title') || el.getAttribute('data-name');
              if (nm === dn && !el.querySelector('.li-dtf-new')) { var b = document.createElement('span'); b.className = 'li-dtf-new'; b.textContent = 'New'; el.appendChild(b); }
            });
          });
        }).catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dtfMarkNew); else dtfMarkNew();

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-li-dtf-track]')) return;
    clearTimeout(t.__liT);
    t.__liT = setTimeout(function () { dtfGalSync(t); }, 60);
  }, true);
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-li-dtf-go], [data-li-dtf-dir]') : null;
    if (!el) return;
    var card = el.closest('.li-dtf-card'), gal = card ? card.querySelector('[data-li-dtf-gal]') : null;
    var track = gal ? gal.querySelector('[data-li-dtf-track]') : null;
    if (!track) return;
    e.preventDefault();
    var cur = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    if (el.hasAttribute('data-li-dtf-dir')) {
      var n = track.children.length, nx = cur + (+el.getAttribute('data-li-dtf-dir'));
      dtfGalGo(gal, (nx + n) % n);
    } else {
      dtfGalGo(gal, +el.getAttribute('data-li-dtf-go'));
    }
  });

  /* Portal Digital print card: a garment chip opens that garment on the
     design the card is showing (the gallery keeps ?design= on the card link). */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest ? e.target.closest('[data-li-dtf-chip]') : null;
    if (!chip) return;
    var wrap = chip.closest('.card-wrapper');
    var link = wrap ? wrap.querySelector('[data-li-card-link]') : null;
    var design = '';
    try { design = new URL(link ? link.href : '', window.location.href).searchParams.get('design') || ''; } catch (x) {}
    if (!design) return;
    e.preventDefault();
    window.location.href = chip.getAttribute('href').split('?')[0] + '?design=' + encodeURIComponent(design);
  });

  window.LIShowCartPopup = showPopup;
  window.LIHideCartPopup = hidePopup;

})();


// ── Cart page renderer ────────────────────────────────────────────────────────

(function () {
  var CONTAINER_ID = 'li-items-container';
  function fmt(n) { return '$' + parseFloat(n || 0).toFixed(2); }
  function fixSrc(u) { return u && u.indexOf('//') === 0 ? 'https:' + u : (u || ''); }

  /* ── FIX 1: money property lookup ──────────────────────────────────────────
     Order sections do not agree on what they call the engine's line total.
     dtf-order and screenprint write "Order total", footy shorts writes
     "Grand total", older sections wrote "Line total" or "Total". This chain
     used to start at "Grand total", so every line whose only money property
     was "Order total" (screenprint, caps, bar mats, accessories) fell through
     to item.original_line_price, which is Shopify's variant price x quantity
     and NOT the engine's figure. On order #1039 that showed a bar mat line as
     $60,000.00 against the engine's stated $1,100.00.
     Shopify's own number stays as a last resort only.
     ──────────────────────────────────────────────────────────────────────── */
  var MONEY_PROPS = ['Order total', 'Grand total', 'Line total', 'Total'];
  function propMoney(props) {
    if (!props) return null;
    for (var i = 0; i < MONEY_PROPS.length; i++) {
      var raw = props[MONEY_PROPS[i]];
      if (raw === undefined || raw === null || raw === '') continue;
      var n = parseFloat(String(raw).replace(/[^0-9.\-]/g, ''));
      if (!isNaN(n)) return n;
    }
    return null;
  }

  /* ── FIX 3 helper: the engine's own unit count ─────────────────────────────
     Shopify's line quantity is what an invoice and the order record read, so
     when it disagrees with the engine the billing is wrong, not just the
     display. The sections state the true count on the line itself:
     "Total units" (dtf/screenprint) or "Quantity" (accessories/bar mats).
     ──────────────────────────────────────────────────────────────────────── */
  /* Only the order sections' own lines get their quantity rewritten. A plain
     product that happens to carry a property called "Quantity" must be left
     alone, or we would silently change a cart line nobody asked us to touch. */
  function isEngineLine(props) {
    if (!props) return false;
    if (props['Print method'] || props['Order type'] || props['Product type'] || props['Tier']) return true;
    return Object.keys(props).some(function (k) { return /^Line \d+/i.test(k); });
  }

  /* Rebuild the whole Tier string from the table the section published, so the
     label and the prices are always computed from the same live unit count. */
  function tierStringFor(rawTable, units) {
    var table;
    try { table = JSON.parse(rawTable); } catch (e) { return null; }
    if (!Array.isArray(table) || !table.length) return null;
    var best = null;
    table.forEach(function (t) {
      var min = parseInt(t.min, 10);
      if (!isFinite(min)) return;
      if (units >= min && (!best || min > parseInt(best.min, 10))) best = t;
    });
    if (!best) return 'Below minimum';
    var parts = Object.keys(best.p || {}).map(function (k) { return k + ' ' + best.p[k]; });
    return parseInt(best.min, 10) + '+ units' + (parts.length ? ' | ' + parts.join(' | ') : '');
  }

  function statedUnits(props) {
    if (!props) return null;
    var raw = props['Total units'];
    if (raw === undefined || raw === null || raw === '') raw = props['Quantity'];
    if (raw === undefined || raw === null || raw === '') return null;
    var n = parseInt(String(raw).replace(/[^0-9]/g, ''), 10);
    return (isFinite(n) && n > 0) ? n : null;
  }

  /* A DTF line value reads "Adult Tee: S x2 M x3  |  Kids Tee: K6 x1", and
     dtf-order appends "\nNotes: ..." when the client typed notes. Split the
     notes off first so they are shown as notes and never read as sizes. */
  function splitDTFValue(raw) {
    var s = String(raw == null ? '' : raw);
    var i = s.search(/\r?\nNotes:\s*/);
    if (i < 0) return { sizes: s, notes: '' };
    return { sizes: s.slice(0, i), notes: s.slice(i).replace(/^\r?\nNotes:\s*/, '').trim() };
  }

  /* Garment-only money for a DTF line at the per-garment prices in a Tier
     string. Used to move a line between tiers without losing the surcharges
     (oversize, zip, style, locations) that the section already put in
     'Order total'. Returns null when the Tier carries no prices. */
  function dtfBaseAt(props, tierStr) {
    var prices = {};
    String(tierStr || '').split('|').forEach(function (part) {
      var m = part.trim().match(/^(.+?)\s+\$(\d+\.?\d*)$/);
      if (m) prices[m[1].trim().toLowerCase()] = parseFloat(m[2]);
    });
    if (!Object.keys(prices).length) return null;
    var total = 0;
    Object.keys(props).forEach(function (k) {
      if (!/^Line \d+/i.test(k)) return;
      var v = splitDTFValue(props[k]).sizes;
      if (v.indexOf(':') < 0) return;
      v.split('|').forEach(function (group) {
        var ci = group.indexOf(':');
        if (ci < 0) return;
        var unitPrice = prices[group.slice(0, ci).trim().toLowerCase()] || 0;
        if (!unitPrice) return;
        var toks = group.slice(ci + 1).trim().split(/\s+/);
        for (var i = 0; i < toks.length - 1; i += 2) {
          var qt = toks[i + 1] || '';
          if (qt.charAt(0) === 'x' || qt.charAt(0) === 'X') total += (parseInt(qt.slice(1), 10) || 0) * unitPrice;
        }
      });
    });
    return total;
  }

  /* Money for a DTF line at a given tier. Starts from the section's own
     'Order total' (which includes every surcharge) and only swaps the garment
     price difference between the stored tier and the new one. */
  function dtfMoneyAt(props, newTier) {
    var engine = propMoney(props);
    var stored = props['Tier'] || '';
    if (engine === null) {
      var calc = dtfBaseAt(props, newTier || stored);
      return calc;
    }
    if (!newTier || newTier === stored) return engine;
    var oldBase = dtfBaseAt(props, stored);
    var newBase = dtfBaseAt(props, newTier);
    if (oldBase === null || newBase === null) return engine;
    return Math.round((engine - oldBase + newBase) * 100) / 100;
  }

  /* Last cart lines drawn, so a removed line can be put back by Undo. */
  var _lastShopifyItems = [];

  window.liRemoveLine = function(lineIndex) {
    var gone = _lastShopifyItems[lineIndex - 1] || null;
    _rawFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    }).then(liReadCartJson).then(function() {
      render();
      if (gone) undoToast(gone.product_title || 'Line', function () {
        return _rawFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: gone.variant_id, quantity: gone.quantity, properties: gone.properties || {} }] })
        }).then(liReadCartJson);
      });
    }).catch(function(err) {
      render();
      undoToast(null, null, (err && err.message) || 'Could not remove that line.');
    });
  };

  /* Toast at the bottom of the page: "Removed X. Undo". Lives on <body>, so
     a cart section re-render can't wipe it. */
  var _toastTimer = null;
  function undoToast(name, undo, errorText) {
    var t = document.getElementById('li-undo-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'li-undo-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.textContent = '';
    t.className = errorText ? 'is-error' : '';
    var msg = document.createElement('span');
    msg.textContent = errorText || ('Removed ' + String(name).slice(0, 60));
    t.appendChild(msg);
    if (undo) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = 'Undo';
      b.addEventListener('click', function () {
        b.disabled = true;
        undo().then(function () {
          t.hidden = true;
          render();
          if (window.LIOrder && window.LIOrder.updateBadge) window.LIOrder.updateBadge();
        }).catch(function (err) {
          msg.textContent = 'Could not put it back: ' + ((err && err.message) || 'cart error');
          b.remove();
        });
      });
      t.appendChild(b);
    }
    t.hidden = false;
    clearTimeout(_toastTimer);
    _toastTimer = setTimeout(function () { t.hidden = true; }, 8000);
  }

  /* One delegated listener for every remove button (no inline onclick).
     Shopify lines carry data-li-line, saved order-builder lines data-li-id. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.li-item-remove') : null;
    if (!btn || !document.getElementById(CONTAINER_ID)) return;
    e.preventDefault();
    var card = btn.closest('.li-item-remove--icon') ? btn.closest('.li-design') : btn.closest('.li-card');
    if (card) card.style.opacity = '0.4';
    btn.disabled = true;
    if (btn.dataset.liLine) window.liRemoveLine(parseInt(btn.dataset.liLine, 10));
    else if (btn.dataset.liId && window.LIOrder) {
      var saved = null;
      window.LIOrder.items().some(function (it) { if (it.id === btn.dataset.liId) { saved = it; return true; } return false; });
      window.LIOrder.remove(btn.dataset.liId);
      render();
      if (saved) undoToast(saved.productTitle || saved.design || 'Line', function () {
        var copy = JSON.parse(JSON.stringify(saved));
        window.LIOrder.add(copy);
        return Promise.resolve();
      });
    }
  });

  /* ── Cart UI building blocks ───────────────────────────────────────────────
     Every line renders through card(), so DTF, caps, beanies, quotes, design
     briefs and saved builder lines all share one layout. Styles live in
     sections/main-cart-items.liquid. */
  function piecesLabel(n) {
    n = parseInt(n, 10) || 0;
    return n + (n === 1 ? ' piece' : ' pieces');
  }

  function thumb(src) {
    return '<div class="li-thumb">' + (src
      ? '<img src="' + liEsc(fixSrc(src)) + '" alt="" loading="lazy">'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M8 4 4 7l2 3 2-1v11h8V9l2 1 2-3-4-3c-.5 1.5-2 2.5-4 2.5S8.5 5.5 8 4z"/></svg>') +
    '</div>';
  }

  function removeButton(attr, name) {
    return '<button type="button" class="li-item-remove" ' + attr + ' aria-label="Remove ' + liEsc(name || 'line') + '">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>' +
      '<span>Remove</span></button>';
  }

  /* "2XL x21 10/11XL x41" -> [['2XL',21],['10/11XL',41]] */
  function sizePairs(str) {
    var out = [];
    var toks = String(str || '').trim().split(/\s+/);
    for (var i = 0; i < toks.length - 1; i += 2) {
      var q = toks[i + 1] || '';
      if (q.charAt(0) === 'x' || q.charAt(0) === 'X') {
        var n = parseInt(q.slice(1), 10);
        if (n > 0) out.push([toks[i], n]);
      }
    }
    return out;
  }

  function sizeCells(pairs) {
    return '<div class="li-sizes">' + pairs.map(function (p) {
      return '<span class="li-size"><span class="li-size-k">' + liEsc(p[0]) + '</span><span class="li-size-v">' + liEsc(p[1]) + '</span></span>';
    }).join('') + '</div>';
  }

  /* One design (or design + colour + style) and its sizes, per garment. */
  function designBlock(heading, garments, notes, extraHead) {
    var parts = String(heading || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    var name = parts.shift() || 'Design';
    var units = 0;
    garments.forEach(function (g) { g.pairs.forEach(function (p) { units += p[1]; }); });
    return '<div class="li-design">' +
      '<div class="li-design-head">' +
        '<span class="li-design-name">' + liEsc(name) + '</span>' +
        (parts.length ? '<span class="li-design-detail">' + liEsc(parts.join(' · ')) + '</span>' : '') +
        (units ? '<span class="li-design-count">' + piecesLabel(units) + '</span>' : '') +
        (extraHead || '') +
      '</div>' +
      garments.map(function (g) {
        return '<div class="li-garment">' +
          (g.label ? '<span class="li-garment-lbl">' + liEsc(g.label) + '</span>' : '') +
          (g.pairs.length ? sizeCells(g.pairs) : '<span class="li-garment-raw">' + liEsc(g.raw || '') + '</span>') +
        '</div>';
      }).join('') +
      (notes ? '<p class="li-notes">' + liEsc(notes) + '</p>' : '') +
    '</div>';
  }

  /* Key / value rows: options, fees. */
  function specRows(rows) {
    if (!rows.length) return '';
    return '<dl class="li-specs">' + rows.map(function (r) {
      return '<div class="li-spec"><dt>' + liEsc(r[0]) + '</dt><dd>' + liEsc(r[1]) + '</dd></div>';
    }).join('') + '</dl>';
  }

  /* "100+ units | Adult Hood $56.90" or "50+ units @ $30.95/unit" -> "100+ price" */
  function breakTag(tier) {
    var m = String(tier || '').match(/^(\d+)\+/);
    if (m) return m[1] + '+ price';
    return /below minimum/i.test(tier || '') ? 'Below minimum' : '';
  }

  function card(o) {
    var titleTag = o.url
      ? '<a class="li-card-title" href="' + liEsc(o.url) + '">' + liEsc(o.title) + '</a>'
      : '<span class="li-card-title">' + liEsc(o.title) + '</span>';
    return '<article class="li-card' + (o.cls ? ' ' + o.cls : '') + '">' +
      '<div class="li-card-head">' +
        thumb(o.img) +
        '<div class="li-card-info">' +
          (o.method ? '<span class="li-card-eyebrow">' + liEsc(o.method) + '</span>' : '') +
          titleTag +
          (o.meta ? '<p class="li-card-meta">' + liEsc(o.meta) + '</p>' : '') +
        '</div>' +
        '<div class="li-card-price">' +
          '<span class="li-card-total' + (o.quote ? ' is-quote' : '') + '">' + liEsc(o.total) + '</span>' +
          (o.unit ? '<span class="li-card-unit">' + liEsc(o.unit) + '</span>' : '') +
        '</div>' +
      '</div>' +
      (o.body ? '<div class="li-card-body">' + o.body + '</div>' : '') +
      '<div class="li-card-foot">' +
        '<div class="li-card-tags">' + (o.tags || []).filter(Boolean).map(function (t) {
          return '<span class="li-tag">' + liEsc(t) + '</span>';
        }).join('') + '</div>' +
        ((o.edit || o.removeBtn) ? '<div class="li-card-acts" style="display:flex;align-items:center;gap:18px">' +
          (o.edit ? '<a class="li-text-link li-card-edit" style="margin:0" href="' + liEsc(o.edit) + '">Edit sizes</a>' : '') +
          (o.removeBtn || '') + '</div>' : '') +
      '</div>' +
    '</article>';
  }

  /* Builder brief lines are $0 quote requests. Show the design itself, the
     client's notes and a link back into the builder, never "$0.00". */
  function renderBriefItem(item, removeBtn) {
    var b = liBriefInfo(item.properties || {});
    var body = '';
    if (b.notes) body += '<p class="li-notes">' + liEsc(b.notes) + '</p>';
    if (b.link) body += '<a class="li-text-link" href="' + liEsc(b.link) + '" target="_blank" rel="noopener">View design</a>';
    return card({
      cls: 'li-card--brief', img: b.img, method: 'Design brief', title: b.title, meta: b.sub,
      total: 'Quoted after review', quote: true, body: body, removeBtn: removeBtn
    });
  }

  /* Quote lines (an order section in quote mode). Units and notes are real,
     the price comes after review. */
  function renderQuoteItem(item, imgSrc, removeBtn) {
    var props = item.properties || {};
    var units = statedUnits(props) || item.quantity;
    var bits = [];
    if (props['Design']) bits.push(props['Design']);
    bits.push(piecesLabel(units));
    return card({
      img: imgSrc, method: 'Quote', title: item.product_title, url: item.url, meta: bits.join(' · '),
      total: 'Quoted after review', quote: true,
      body: props['Notes'] ? '<p class="li-notes">' + liEsc(props['Notes']) + '</p>' : '',
      removeBtn: removeBtn
    });
  }

  // ── Parse DTF line properties into clean display objects ──
  // Handles new grouped format: "Line 1 - Design - Colour": "Adult Hood: L x1 XL x1"
  // Also handles old flat format: "Line 1 Adult Hood XS": 10
  function parseDTFLines(props) {
    var lines = [];
    var maxLine = 0;
    Object.keys(props).forEach(function(k) {
      var m = k.match(/^Line (\d+)/i);
      if (m) maxLine = Math.max(maxLine, parseInt(m[1]));
    });
    if (maxLine === 0) return lines;

    for (var n = 1; n <= maxLine; n++) {
      var prefix = 'Line ' + n;

      // ── New grouped format: key is "Line N - Design - Colour", value is "Adult Hood: L x1 XL x1 | Kids Tee: K6 x3" ──
      var newKey = null;
      var newVal = null;
      Object.keys(props).forEach(function(k) {
        if (k === prefix) return;
        if (k.indexOf(prefix) !== 0) return;
        var rest = k.slice(prefix.length);
        // New format keys start with " - " after "Line N"
        if (rest.indexOf(' - ') === 0 && !/ Notes$/.test(rest)) {
          var val = String(props[k]);
          // Value contains garment data like "Adult Hood: L x1"
          if (val.indexOf(':') > -1) {
            newKey = k;
            newVal = val;
          }
        }
      });

      if (newKey) {
        // Extract heading from key: "Line 1 - ROCK HARD GREEN 26 - Black - No Zip" -> "ROCK HARD GREEN 26 | Black | No Zip"
        var headRaw = newKey.slice(prefix.length).replace(/^ - /, '');
        var heading = headRaw.split(' - ').filter(function(p){ return p !== 'No Zip'; }).join(' | ');
        // Notes ride either inside the value ("\nNotes: ...") or, on older
        // lines, in their own "Line N - Design Notes" property.
        var split = splitDTFValue(newVal);
        var notes = split.notes || props[prefix + ' Notes'] || props[newKey + ' Notes'] || '';
        // Parse garment groups from value: "Adult Hood: L x1 XL x1 | Kids Tee: K6 x3"
        var garmentGroups = split.sizes.split('|').map(function(g){ return g.trim(); }).filter(Boolean);
        lines.push({ heading: heading, garmentGroups: garmentGroups, notes: notes });
        continue;
      }

      // ── Old flat format: "Line 1 Adult Hood XS": 10 ──
      var design    = props[prefix + ' Design'] || '';
      var colour    = props[prefix + ' Colour'] || '';
      var hoodStyle = props[prefix + ' Hood style'] || '';
      var style     = props[prefix + ' Style'] || '';
      var notes2    = props[prefix + ' Notes'] || '';

      var heading2 = '';
      if (design)    heading2 += design;
      if (colour)    heading2 += (heading2 ? ' | ' : '') + colour;
      if (hoodStyle && hoodStyle !== 'No Zip') heading2 += (heading2 ? ' | ' : '') + hoodStyle;
      if (style)     heading2 += (heading2 ? ' | ' : '') + style;

      var garmentMap = {};
      var garmentOrder = ['Adult tee','Adult Hood','Adult Sweater','Kids tee','Kids hood','Kids Sweater'];
      Object.keys(props).forEach(function(k) {
        if (k.indexOf(prefix + ' ') !== 0) return;
        var suffix = k.slice(prefix.length + 1);
        if (['Design','Colour','Hood style','Style','Notes'].indexOf(suffix) >= 0) return;
        var qty = parseInt(props[k]);
        if (!qty || qty < 1) return;
        var parts = suffix.match(/^(.+?)\s+([^\s]+)$/);
        if (!parts) return;
        var garment = parts[1];
        var size    = parts[2];
        if (!garmentMap[garment]) garmentMap[garment] = [];
        garmentMap[garment].push(size + ' x' + qty);
      });

      var garmentGroups2 = [];
      garmentOrder.forEach(function(g) {
        if (garmentMap[g]) garmentGroups2.push(g + ': ' + garmentMap[g].join(' '));
      });
      Object.keys(garmentMap).forEach(function(g) {
        if (garmentOrder.indexOf(g) < 0) garmentGroups2.push(g + ': ' + garmentMap[g].join(' '));
      });

      if (garmentGroups2.length || heading2) {
        lines.push({ heading: heading2, garmentGroups: garmentGroups2, notes: notes2 });
      }
    }
    return lines;
  }

  /* Price per piece for the card: "$56.90 each" when the whole line is one
     price, otherwise the average ("avg $61.09 each", e.g. zips or oversize). */
  function unitLabel(money, units, tier) {
    units = parseInt(units, 10) || 0;
    if (!units || money === null || money === undefined) return '';
    var per = Math.round(money / units * 100) / 100;
    var prices = String(tier || '').match(/\$\d+(\.\d+)?/g) || [];
    if (prices.length === 1 && Math.abs(parseFloat(prices[0].slice(1)) - per) < 0.006) return fmt(per) + ' each';
    return 'avg ' + fmt(per) + ' each';
  }

  /* "100+ units | Adult Hood $56.90 | Kids Tee $25.40" -> ["Adult Hood $56.90", ...] */
  function tierPriceTags(tier) {
    return String(tier || '').split('|').slice(1).map(function (s) { return s.trim(); }).filter(function (s) { return /\$\d/.test(s); });
  }

  function countDesigns(lines) {
    var seen = [];
    lines.forEach(function (l) {
      var n = String(l.heading || '').split('|')[0].trim().toLowerCase();
      if (n && seen.indexOf(n) < 0) seen.push(n);
    });
    return seen.length || lines.length;
  }

  // ── Render Shopify cart line items ──
  function renderShopifyItem(item, lineIndex, liveDTFUnits) {
    var props = item.properties || {};
    var printMethod = props['Print method'] || '';
    // dtf-order hands over the preview the client was looking at, because every
    // submission posts the same blank base variant.
    var imgSrc = props['_preview_image'] ||
      (item.featured_image && item.featured_image.url ? item.featured_image.url : (item.image || ''));
    var removeBtn = removeButton('data-li-line="' + lineIndex + '"', item.product_title);

    // Builder briefs first: liIsQuote() is true for them too.
    if (liIsBrief(props)) return renderBriefItem(item, removeBtn);
    if (liIsQuote(props)) return renderQuoteItem(item, imgSrc, removeBtn);

    var isDTF = (printMethod === 'DTF' || printMethod === 'Digital');
    var method = isDTF ? 'Digital print' : printMethod;
    var units = statedUnits(props) || item.quantity || 0;
    var hasLineProps = Object.keys(props).some(function (k) { return /^Line \d+/i.test(k); });

    // ── DTF order ──
    if (isDTF && hasLineProps) {
      var tier = props['_tier_table']
        ? (tierStringFor(props['_tier_table'], liveDTFUnits || 0) || props['Tier'] || 'Below minimum')
        : (props['Tier'] || 'Below minimum');
      var dtfLines = parseDTFLines(props);
      var body = dtfLines.map(function (line) {
        return designBlock(line.heading, line.garmentGroups.map(function (g) {
          var ci = g.indexOf(':');
          if (ci < 0) return { label: '', pairs: [], raw: g };
          return { label: g.slice(0, ci).trim(), pairs: sizePairs(g.slice(ci + 1)), raw: g };
        }), line.notes);
      }).join('');
      var money = dtfMoneyAt(props, props['_tier_table'] ? tier : null);
      if (money === null) money = item.original_line_price / 100;
      var nd = countDesigns(dtfLines);
      return card({
        img: imgSrc, method: method, title: item.product_title, url: item.url,
        meta: piecesLabel(units) + ' · ' + nd + ' design' + (nd !== 1 ? 's' : ''),
        total: fmt(money), unit: unitLabel(money, units, tier),
        body: body, tags: [breakTag(tier)].concat(tierPriceTags(tier)), removeBtn: removeBtn,
        // The DTF order page reads what's in the cart, so editing is just opening it
        edit: item.url ? String(item.url).split('?')[0] : ''
      });
    }

    // ── Old multi-design packed format ("Line 1 Design", "Line 1 M": 4) ──
    var lineKeys = Object.keys(props).filter(function (k) { return /^Line \d+ Design$/i.test(k); });
    if (lineKeys.length > 0) {
      var maxLine = 0;
      Object.keys(props).forEach(function (k) {
        var m = k.match(/^Line (\d+)/i);
        if (m) maxLine = Math.max(maxLine, parseInt(m[1], 10));
      });
      var blocks = '';
      for (var n = 1; n <= maxLine; n++) {
        var pfx = 'Line ' + n + ' ';
        var lineDesign = props[pfx + 'Design'] || '';
        var hoodStyle = props[pfx + 'Hood style'] || props[pfx + 'Hood Style'] || '';
        var pairs = [];
        Object.keys(props).forEach(function (k) {
          if (k.indexOf(pfx) !== 0) return;
          var suffix = k.replace(pfx, '');
          if (['Design', 'Hood style', 'Hood Style', 'Colour'].indexOf(suffix) >= 0) return;
          var val = parseInt(props[k], 10);
          if (val > 0) pairs.push([suffix, val]);
        });
        if (!lineDesign && !pairs.length) continue;
        var head = lineDesign + (props[pfx + 'Colour'] ? ' | ' + props[pfx + 'Colour'] : '') + (hoodStyle && hoodStyle !== 'No Zip' ? ' | ' + hoodStyle : '');
        blocks += designBlock(head, [{ label: '', pairs: pairs }], '');
      }
      var packed = propMoney(props);
      if (packed === null) packed = item.original_line_price / 100;
      return card({
        img: imgSrc, method: isDTF ? 'Digital print' : printMethod, title: item.product_title, url: item.url,
        meta: piecesLabel(units) + ' · ' + maxLine + ' design' + (maxLine !== 1 ? 's' : ''),
        total: fmt(packed), unit: unitLabel(packed, units, props['Tier']),
        body: blocks, tags: [breakTag(props['Tier'])], removeBtn: removeBtn
      });
    }

    // ── Standard product (caps, beanies, hats, coolers, screen print, footy, fishing) ──
    // Money and bookkeeping keys never show as options.
    var metaKeys = ['Print method', 'Design', 'Colour', 'Colour 1', 'Garment type', 'Tier', 'Garments subtotal',
      'Screen setup fee', 'Screen setup', 'Bagging fee', 'Individual bagging', 'Line total', 'Colour surcharge', 'Total',
      'Order total', 'Grand total', 'Total units', 'Quantity', 'Per unit price', 'Order type', 'Product type',
      'Print locations', 'Location surcharge', 'New design fee', 'Production', 'Stripes', 'Embroidery locations',
      'Cap type', 'Per cap price', 'Caps subtotal', 'Notes'];
    var specs = [];
    var sizeLike = [];
    Object.keys(props).forEach(function (k) {
      var v = props[k];
      if (!v || metaKeys.indexOf(k) >= 0 || String(k).charAt(0) === '_') return;
      // Fishing / footy write one key per size ("Line 1 Adult M": 4): show as size cells.
      var sm = k.match(/^Line \d+\s+(?:(Adult|Kids)\s+)?(.+)$/i);
      if (sm && /^\d+$/.test(String(v))) { sizeLike.push([(sm[1] ? sm[1].charAt(0) + ' ' : '') + sm[2], parseInt(v, 10)]); return; }
      specs.push([k, v]);
    });
    ['Embroidery locations', 'Print locations', 'Cap type', 'Stripes', 'Production'].forEach(function (k) {
      if (props[k]) specs.push([k, props[k]]);
    });
    var fees = [];
    if (props['Garments subtotal']) fees.push(['Garments', props['Garments subtotal']]);
    if (props['Caps subtotal']) fees.push(['Caps', props['Caps subtotal']]);
    if (props['Screen setup fee'] || props['Screen setup']) fees.push(['Screen setup', props['Screen setup fee'] || props['Screen setup']]);
    if (props['New design fee']) fees.push(['New design fee', props['New design fee']]);
    if (props['Colour surcharge']) fees.push(['Colour surcharge', props['Colour surcharge']]);
    if (props['Location surcharge']) fees.push(['Location surcharge', props['Location surcharge']]);
    if (props['Bagging fee'] || props['Individual bagging']) fees.push(['Bagging', props['Bagging fee'] || props['Individual bagging']]);

    var stdMoney = propMoney(props);
    if (stdMoney === null) stdMoney = item.original_line_price / 100;
    var colour = props['Colour 1'] || props['Colour'] || '';
    var metaBits = [];
    if (props['Design']) metaBits.push(props['Design'] + (colour ? ' · ' + colour : ''));
    else if (item.variant_title && item.variant_title !== 'Default Title') metaBits.push(item.variant_title);
    metaBits.push(piecesLabel(units));
    var stated = String(props['Per unit price'] || props['Per cap price'] || '').match(/\d+(\.\d+)?/);
    var tierAt = String(props['Tier'] || '').match(/@\s*\$(\d+(\.\d+)?)/);
    var unitTxt = stated ? fmt(parseFloat(stated[0])) + ' each'
      : tierAt ? fmt(parseFloat(tierAt[1])) + ' each'
      : unitLabel(stdMoney, units, '');
    var stdBody = (sizeLike.length ? '<div class="li-design"><div class="li-garment">' + sizeCells(sizeLike) + '</div></div>' : '') +
      specRows(specs) + (fees.length > 1 ? specRows(fees) : '') +
      (props['Notes'] ? '<p class="li-notes">' + liEsc(props['Notes']) + '</p>' : '');
    return card({
      img: imgSrc, method: method, title: item.product_title, url: item.url,
      meta: metaBits.join(' · '), total: fmt(stdMoney), unit: unitTxt,
      body: stdBody, tags: [breakTag(props['Tier'])], removeBtn: removeBtn
    });
  }

  /* Saved order-builder lines (localStorage), grouped per product. */
  function renderLIGroup(group) {
    var units = 0;
    var body = group.lines.map(function (item) {
      var pairs = Object.keys(item.sizes || {}).map(function (k) { return [k, parseInt(item.sizes[k], 10) || 0]; })
        .filter(function (p) { return p[1] > 0; });
      pairs.forEach(function (p) { units += p[1]; });
      var rm = '<button type="button" class="li-item-remove li-item-remove--icon" data-li-id="' + liEsc(item.id) + '" aria-label="Remove ' + liEsc(item.design || 'line') + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>';
      return designBlock((item.design || 'Design') + (item.colour ? ' | ' + item.colour : ''), [{ label: '', pairs: pairs }], '', rm);
    }).join('');
    var first = group.lines[0] || {};
    return card({
      img: group.productImage, method: group.printMethod, title: group.productTitle, url: group.productUrl,
      meta: piecesLabel(units) + ' · ' + group.lines.length + ' design' + (group.lines.length !== 1 ? 's' : ''),
      total: fmt(group.totalLineTotal), unit: unitLabel(group.totalLineTotal, units, first.tier),
      body: body, tags: [breakTag(first.tier)]
    });
  }

  /* One summary row: product name, then design / method underneath. */
  function sideRow(name, sub, value, muted) {
    return '<div class="li-sum-row">' +
      '<span class="li-sum-row-lbl"><span class="li-sum-name">' + liEsc(name || '') + '</span>' +
        (sub ? '<span class="li-sum-sub">' + liEsc(sub) + '</span>' : '') + '</span>' +
      '<span class="li-sum-row-val' + (muted ? ' is-muted' : '') + '">' + liEsc(value) + '</span>' +
    '</div>';
  }

  /* Digital garments all count together toward one price break. Works out
     the next break, how far away it is and what it saves on what's already
     in the cart. null when there's no digital line or no higher break. */
  function nextBreakInfo(shopifyItems, liveDTFUnits) {
    if (!liveDTFUnits) return null;
    var table = null;
    shopifyItems.some(function (it) {
      var p = it.properties || {};
      var pm = p['Print method'] || '';
      if ((pm === 'DTF' || pm === 'Digital') && p['_tier_table']) {
        try { table = JSON.parse(p['_tier_table']); } catch (e) { table = null; }
      }
      return !!table;
    });
    if (!Array.isArray(table)) return null;
    var next = null;
    table.forEach(function (t) {
      var m = parseInt(t.min, 10);
      if (isFinite(m) && m > liveDTFUnits && (next === null || m < next)) next = m;
    });
    if (next === null) return { best: true, units: liveDTFUnits };
    var nowCost = 0, nextCost = 0;
    shopifyItems.forEach(function (it) {
      var p = it.properties || {};
      var pm = p['Print method'] || '';
      if (!(pm === 'DTF' || pm === 'Digital') || !p['_tier_table'] || liIsQuote(p)) return;
      var a = dtfMoneyAt(p, tierStringFor(p['_tier_table'], liveDTFUnits));
      var b = dtfMoneyAt(p, tierStringFor(p['_tier_table'], next));
      if (a === null || b === null) return;
      nowCost += a; nextCost += b;
    });
    // Where "Add more pieces" goes: the DTF order page of the biggest digital line in the cart
    var addUrl = '', addUnits = -1;
    shopifyItems.forEach(function (it) {
      var p = it.properties || {}, pm = p['Print method'] || '';
      if ((pm === 'DTF' || pm === 'Digital') && it.url && (it.quantity || 0) > addUnits) { addUnits = it.quantity || 0; addUrl = String(it.url).split('?')[0]; }
    });
    return { units: liveDTFUnits, next: next, need: next - liveDTFUnits, save: Math.round((nowCost - nextCost) * 100) / 100, url: addUrl };
  }

  function renderBreak(info) {
    var el = document.getElementById('li-next-break');
    if (!el) return;
    if (!info) { el.hidden = true; el.innerHTML = ''; return; }
    el.hidden = false;
    if (info.best) {
      el.innerHTML = '<div class="li-break-top"><span>Digital price break</span><span>' + info.units + ' pieces</span></div>' +
        '<div class="li-break-bar"><span style="width:100%"></span></div>' +
        '<p class="li-break-text">You\'re on the best digital price.</p>';
      return;
    }
    var pct = Math.max(4, Math.min(100, Math.round(info.units / info.next * 100)));
    el.innerHTML = '<div class="li-break-top"><span>Digital price break</span><span>' + info.units + ' / ' + info.next + '</span></div>' +
      '<div class="li-break-bar" role="progressbar" aria-valuemin="0" aria-valuemax="' + info.next + '" aria-valuenow="' + info.units + '"><span style="width:' + pct + '%"></span></div>' +
      '<p class="li-break-text">Add <strong>' + info.need + ' more</strong> digital piece' + (info.need !== 1 ? 's' : '') + ' for the ' + info.next + '+ price' +
        (info.save > 0 ? ' and save <strong>' + fmt(info.save) + '</strong> on this order.' : '.') + '</p>' +
      (info.url ? '<a class="li-break-add" href="' + liEsc(info.url) + '" style="display:inline-flex;align-items:center;gap:6px;margin-top:10px;padding:7px 14px;border:1px solid rgba(47,191,113,0.5);border-radius:999px;color:#2fbf71;font-size:13px;font-weight:700;text-decoration:none">Add ' + info.need + ' more pieces <span aria-hidden="true">&rarr;</span></a>' : '');
  }

  function updateExtras(grand, breakInfo, canSubmit) {
    var gst = document.getElementById('li-gst');
    if (gst) {
      gst.textContent = grand > 0 ? 'Includes ' + fmt(Math.round(grand / 11 * 100) / 100) + ' GST' : '';
      gst.hidden = !(grand > 0);
    }
    renderBreak(breakInfo);
    stickyBar(grand, canSubmit);
  }

  /* Phone: total + checkout stuck to the bottom of the screen. It presses the
     real button, so notes and errors work the same. Hidden while the real
     button is on screen. Lives on <body>, so re-renders don't wipe it. */
  var _stickyIO = null;
  function stickyBar(grand, canSubmit) {
    var real = document.getElementById('li-submit-btn');
    var bar = document.getElementById('li-cart-sticky-bar');
    if (!real || !document.getElementById(CONTAINER_ID)) { if (bar) bar.hidden = true; return; }
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'li-cart-sticky-bar';
      bar.className = 'li-cart-sticky-bar';
      bar.innerHTML = '<div class="li-csb-total"><span class="li-csb-lbl">Total inc GST</span><span class="li-csb-val" id="li-csb-val"></span></div>' +
        '<button type="button" class="li-csb-btn" id="li-csb-btn">Checkout</button>';
      document.body.appendChild(bar);
      bar.querySelector('#li-csb-btn').addEventListener('click', function () {
        var btn = document.getElementById('li-submit-btn');
        if (!btn || btn.disabled) return;
        btn.click();
        var err = document.getElementById('li-submit-error');
        setTimeout(function () { if (err && !err.hidden) err.scrollIntoView({ block: 'center' }); }, 400);
      });
    }
    bar.hidden = false;
    bar.querySelector('#li-csb-val').textContent = fmt(grand);
    bar.querySelector('#li-csb-btn').disabled = !canSubmit;
    bar.dataset.empty = grand > 0 || canSubmit ? '0' : '1';
    if ('IntersectionObserver' in window) {
      if (_stickyIO) _stickyIO.disconnect();
      _stickyIO = new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-covered', entries.some(function (e) { return e.isIntersecting; }));
      });
      _stickyIO.observe(real);
    }
  }

  /* Order notes survive a cart section re-render. */
  function restoreFields() {
    var el = document.getElementById('li-note');
    if (!el || el.dataset.liBound) return;
    el.dataset.liBound = '1';
    try { if (!el.value) el.value = sessionStorage.getItem('li_cart_note') || ''; } catch (e) {}
    el.addEventListener('input', function () {
      try { sessionStorage.setItem('li_cart_note', el.value); } catch (e) {}
    });
  }

  /* Header cart count = pieces (Shopify quantities are the real unit counts)
     plus saved builder lines. */
  function setHeaderCount(liItems, shopifyItems) {
    if (!window.LIOrder || !window.LIOrder._applyBadge) return;
    var n = 0;
    shopifyItems.forEach(function (it) { n += parseInt(it.quantity, 10) || 0; });
    liItems.forEach(function (it) {
      Object.keys(it.sizes || {}).forEach(function (k) { n += parseInt(it.sizes[k], 10) || 0; });
    });
    window.LIOrder._applyBadge(n);
  }

  // ── Main render ──
  function render() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return;
    var liItems = window.LIOrder ? window.LIOrder.items() : [];
    _rawFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { doRender(liItems, cart.items || []); })
      .catch(function () { doRender(liItems, []); });
  }

  function doRender(liItems, shopifyItems) {
    var container = document.getElementById(CONTAINER_ID);
    var sidebar   = document.getElementById('li-sidebar-rows');
    var totalEl   = document.getElementById('li-total');
    var countLbl  = document.getElementById('li-item-count-label');
    if (!container) return;

    var total = liItems.length + shopifyItems.length;
    var quoteNote = document.getElementById('li-quote-note');
    var submitEl  = document.getElementById('li-submit-btn');
    setHeaderCount(liItems, shopifyItems);

    if (total === 0) {
      // Copy and links come from the hidden #li-cart-meta div in the section.
      // /collections/all already redirects guests to The Range and clients
      // to their own collection (layout/theme.liquid).
      var meta = liCartMeta();
      var ds = meta ? meta.dataset : {};
      var shopUrl = ds.shopUrl || '/collections/all';
      var builderUrl = ds.builderUrl || '/pages/product-builder';
      var isClient = ds.loggedIn === 'true';
      var pendingHtml = '';
      try {
        var pend = JSON.parse(localStorage.getItem('li_pending_checkout') || 'null');
        if (pend && pend.url && /^https:\/\//.test(pend.url) && Date.now() - (pend.at || 0) < 14 * 86400000) {
          pendingHtml = '<div class="li-pending"><a class="li-btn li-btn--primary" href="' + liEsc(pend.url) + '">Finish checkout' + (pend.name ? ' for ' + liEsc(pend.name) : '') + '</a>' +
            '<p>Already finished? You can ignore this.</p></div>';
        }
      } catch (e) {}
      container.innerHTML =
        '<div class="li-empty">' +
          '<svg class="li-empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.6 7.9h14.8l-.85 11.8a2.05 2.05 0 0 1-2.05 1.9H7.5a2.05 2.05 0 0 1-2.05-1.9L4.6 7.9z"/><path d="M9 10.7V6.9a3 3 0 0 1 6 0v3.8"/></svg>' +
          '<h2>Your order is empty</h2>' + pendingHtml +
          '<p>' + (isClient ? 'Pick from your range, or design new headwear in the builder.' : 'Pick from The Range, or design your own headwear in the builder.') + '</p>' +
          '<div class="li-empty-actions">' +
            '<a href="' + liEsc(shopUrl) + '" class="li-btn li-btn--primary">' + (isClient ? 'Your range' : 'Shop The Range') + '</a>' +
            '<a href="' + liEsc(builderUrl) + '" class="li-btn li-btn--ghost">Open the builder</a>' +
          '</div>' +
        '</div>';
      document.body.classList.add('li-cart-is-empty');
      if (sidebar)  sidebar.innerHTML = '<p class="li-sum-empty">No lines yet</p>';
      if (totalEl)  totalEl.textContent = '$0.00';
      if (countLbl) countLbl.textContent = '';
      if (quoteNote) quoteNote.hidden = true;
      if (submitEl) submitEl.disabled = true;
      _lastShopifyItems = [];
      updateExtras(0, null, false);
      restoreFields();
      return;
    }
    document.body.classList.remove('li-cart-is-empty');
    if (submitEl) submitEl.disabled = false;

    var html = [], sidebarHtml = [], grand = 0, pieces = 0;

    // Group localStorage items
    var liGroups = [];
    var liGroupMap = {};
    liItems.forEach(function (item) {
      var key = (item.productId || item.productTitle) + '|' + item.printMethod;
      if (!liGroupMap[key]) {
        liGroupMap[key] = { key: key, productId: item.productId, productTitle: item.productTitle,
          productUrl: item.productUrl, productImage: item.productImage,
          printMethod: item.printMethod, lines: [], totalLineTotal: 0 };
        liGroups.push(liGroupMap[key]);
      }
      liGroupMap[key].lines.push(item);
      liGroupMap[key].totalLineTotal += parseFloat(item.lineTotal || 0);
      Object.keys(item.sizes || {}).forEach(function (k) { pieces += parseInt(item.sizes[k], 10) || 0; });
    });

    liGroups.forEach(function (group) {
      grand += group.totalLineTotal;
      html.push(renderLIGroup(group));
      sidebarHtml.push(sideRow(group.productTitle, group.printMethod, fmt(group.totalLineTotal)));
    });

    // Live tier from total DTF units across all cart items
    var liveDTFUnits = 0;
    shopifyItems.forEach(function (item) {
      var p = item.properties || {};
      var pm = p['Print method'] || '';
      if (pm === 'DTF' || pm === 'Digital') liveDTFUnits += statedUnits(p) || item.quantity || 0;
    });
    // Sync stored Tier property and line quantities so checkout and the invoice agree
    syncCartLines(shopifyItems);

    _lastShopifyItems = shopifyItems.slice();
    var briefCount = 0, quoteCount = 0;
    shopifyItems.forEach(function (item, i) {
      html.push(renderShopifyItem(item, i + 1, liveDTFUnits));
      var ip = item.properties || {};
      if (!liIsBrief(ip)) pieces += (isEngineLine(ip) ? statedUnits(ip) : null) || item.quantity || 0;
      if (liIsQuote(ip)) {
        // Briefs and quote-mode lines are priced after review: never $0.00.
        if (liIsBrief(ip)) briefCount++; else quoteCount++;
        var qLabel = liIsBrief(ip) ? liBriefInfo(ip).title : (ip['Product'] || item.product_title);
        sidebarHtml.push(sideRow(qLabel, ip['Design'] || '', 'Quote', true));
        return;
      }
      var pm3 = ip['Print method'] || '';
      var isDTF3 = pm3 === 'DTF' || pm3 === 'Digital';
      /* DTF lines move between tiers as the cart grows. dtfMoneyAt starts
         from the section's own 'Order total', so oversize, zip, style and
         location surcharges are kept. */
      var liveTier = (isDTF3 && ip['_tier_table']) ? tierStringFor(ip['_tier_table'], liveDTFUnits) : null;
      var calcedPrice = isDTF3 ? dtfMoneyAt(ip, liveTier) : null;
      var propPrice = propMoney(ip);
      var linePrice = calcedPrice !== null ? calcedPrice
        : propPrice !== null ? propPrice
        : item.original_line_price / 100;
      grand += linePrice;
      var method = pm3 ? (isDTF3 ? 'Digital' : pm3) : '';
      var lineDesigns = [];
      Object.keys(ip).forEach(function (k) {
        var m = k.match(/^Line \d+\s*-\s*(.+)$/i);
        if (!m) return;
        var d = m[1].split(/\s+-\s+|\//)[0].trim();
        if (d && lineDesigns.indexOf(d) < 0) lineDesigns.push(d);
      });
      var subBits = [];
      if (ip['Design']) subBits.push(ip['Design']);
      else if (lineDesigns.length) subBits.push(lineDesigns.length > 2 ? lineDesigns.length + ' designs' : lineDesigns.join(', '));
      else if (item.variant_title && item.variant_title !== 'Default Title' && !isDTF3) subBits.push(item.variant_title);
      if (method) subBits.push(method);
      sidebarHtml.push(sideRow(item.product_title, subBits.join(' · '), fmt(linePrice)));
    });

    container.innerHTML = html.join('');
    if (sidebar)  sidebar.innerHTML = sidebarHtml.join('');
    if (totalEl)  totalEl.textContent = fmt(grand);
    if (countLbl) countLbl.textContent = total + ' item' + (total !== 1 ? 's' : '') + ' · ' + piecesLabel(pieces);
    if (quoteNote) {
      var parts = [];
      if (briefCount) parts.push(briefCount + ' design brief' + (briefCount !== 1 ? 's' : ''));
      if (quoteCount) parts.push(quoteCount + ' quote item' + (quoteCount !== 1 ? 's' : ''));
      var qn = briefCount + quoteCount;
      quoteNote.hidden = qn === 0;
      quoteNote.textContent = qn
        ? 'Plus ' + parts.join(' and ') + ', priced after we review ' + (qn !== 1 ? 'them' : 'it') + '.'
        : '';
    }

    // DTF minimum check
    if (window.location.pathname !== '/cart') return;
    var DTF_MINIMUM = 25;
    var dtfWarning = document.getElementById('li-dtf-minimum-warning');
    var submitBtn  = document.getElementById('li-submit-btn');
    if (liveDTFUnits > 0 && liveDTFUnits < DTF_MINIMUM) {
      if (!dtfWarning) {
        dtfWarning = document.createElement('div');
        dtfWarning.id = 'li-dtf-minimum-warning';
        dtfWarning.className = 'li-alert';
        dtfWarning.setAttribute('role', 'alert');
        var anchor = document.getElementById('li-next-break') || sidebar;
        if (anchor && anchor.parentElement) anchor.parentElement.insertBefore(dtfWarning, anchor);
        else if (container.parentElement) container.parentElement.appendChild(dtfWarning);
      }
      dtfWarning.textContent = 'Digital print minimum is ' + DTF_MINIMUM + ' pieces in total. You have ' + liveDTFUnits + ', add ' + (DTF_MINIMUM - liveDTFUnits) + ' more to check out.';
      dtfWarning.style.display = '';
      if (submitBtn) submitBtn.disabled = true;
    } else {
      if (dtfWarning) dtfWarning.style.display = 'none';
      if (submitBtn) submitBtn.disabled = false;
    }
    updateExtras(grand, liveDTFUnits >= DTF_MINIMUM ? nextBreakInfo(shopifyItems, liveDTFUnits) : null, !(submitBtn && submitBtn.disabled));
    restoreFields();
  }

  /* ── Sync cart lines to what the engine actually said ──────────────────────
     Two corrections, both written back with /cart/change.js:

     FIX 2  The tier label used to come out as "100++ units", because the label
            already carries its own "+" and the old code appended "+ units".

     FIX 3  Shopify's line quantity is what the order record and the invoice
            read. The sections state the real count on the line itself
            ("Total units", or "Quantity" on accessories and bar mats), and the
            two had drifted apart: order #1039 carried 386 units of adult tees
            on a line Shopify recorded as quantity 50, and 50 bar mats on a
            line recorded as 100. Where the engine states a count, it wins.

     _syncAttempts caps the write/re-render cycle so a line that will not
     settle cannot loop.
     ──────────────────────────────────────────────────────────────────────── */
  var _syncPending = false;
  var _syncAttempts = 0;
  function syncCartLines(shopifyItems) {
    if (_syncPending || _syncAttempts >= 3) return;

    var totalDTF = 0;
    shopifyItems.forEach(function(item) {
      var p = item.properties || {};
      var pm = p['Print method'] || '';
      if (pm === 'DTF' || pm === 'Digital') totalDTF += statedUnits(p) || item.quantity || 0;
    });

    var updates = [];

    shopifyItems.forEach(function(item, i) {
      var props = item.properties || {};
      var pm = props['Print method'] || '';
      var isDTF = (pm === 'DTF' || pm === 'Digital');
      var newProps = null;

      /* Only rewrite Tier when the line carries the table to rebuild it from.
         The old code relabelled from the live count while keeping the prices
         captured at submit, which produced strings whose label and prices
         disagreed. A stale-but-consistent Tier beats a fresh-but-wrong one, so
         a line without the table is left exactly as the section wrote it. */
      if (isDTF && totalDTF > 0 && props['_tier_table']) {
        var storedTier = props['Tier'] || '';
        var correctTier = tierStringFor(props['_tier_table'], totalDTF);
        if (correctTier && storedTier !== correctTier) {
          newProps = {};
          Object.keys(props).forEach(function(k) { newProps[k] = props[k]; });
          newProps['Tier'] = correctTier;
          /* Move the money with the tier. Without this the line kept the old
             tier's 'Order total' while 'Tier' showed the new prices, so the
             order record and the /notify/order email disagreed with the cart
             (order #1045: 100+ tier label, 250+ money). Surcharges are kept. */
          var moved = dtfMoneyAt(props, correctTier);
          if (moved !== null && propMoney(props) !== null) {
            if (newProps['Order total'] !== undefined) newProps['Order total'] = fmt(moved);
            if (newProps['Grand total'] !== undefined) newProps['Grand total'] = fmt(moved);
          }
        }
      }

      var stated = isEngineLine(props) ? statedUnits(props) : null;
      var qtyWrong = (stated !== null && stated !== item.quantity);

      if (newProps || qtyWrong) {
        updates.push({
          line: i + 1,
          quantity: qtyWrong ? stated : item.quantity,
          properties: newProps || props
        });
      }
    });

    if (updates.length === 0) return;
    _syncPending = true;
    _syncAttempts++;

    var promises = updates.map(function(u) {
      return _rawFetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(u)
      });
    });

    Promise.all(promises).then(function() {
      _syncPending = false;
      render();
    }).catch(function() {
      _syncPending = false;
    });
  }

  /* The money the cart shows for one Shopify line, for the checkout submit.
     Same rules as the sidebar: quote lines are priced after review, DTF lines
     move with the live combined tier and keep their surcharges, everything
     else uses the section's own 'Order total'. unitHint is the plain per-unit
     price where the line states one, so the draft order can show it. */
  window.liLineMoney = function (item, liveDTFUnits) {
    var ip = (item && item.properties) || {};
    var units = (isEngineLine(ip) ? statedUnits(ip) : null) || item.quantity || 1;
    if (liIsQuote(ip)) return { quote: true, total: 0, unitHint: null, units: units };
    var pm = ip['Print method'] || '';
    var isDTF = pm === 'DTF' || pm === 'Digital';
    var total = null, hint = null;
    if (isDTF) {
      var liveTier = ip['_tier_table'] ? tierStringFor(ip['_tier_table'], liveDTFUnits || 0) : null;
      total = dtfMoneyAt(ip, liveTier);
      var hintTier = (liveTier && liveTier !== 'Below minimum') ? liveTier : (ip['Tier'] || '');
      var prices = String(hintTier).match(/\$\d+(\.\d+)?/g) || [];
      if (prices.length === 1) hint = parseFloat(prices[0].slice(1));
    } else {
      total = propMoney(ip);
      var per = ip['Per unit price'] || ip['Per cap price'] || '';
      var m = String(per).match(/\d+(\.\d+)?/);
      if (m) hint = parseFloat(m[0]);
    }
    if (total === null && item.original_line_price !== undefined) total = item.original_line_price / 100;
    return { quote: false, total: total, unitHint: hint, units: units };
  };
  window.liStatedUnits = statedUnits;

  window.liRenderCart = render;
  window.addEventListener('li:order:updated', render);

  function observe() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container) return;
    var parent = container.parentElement;
    if (!parent) return;
    var _renderScheduled = false;
    new MutationObserver(function() {
      var el = document.getElementById(CONTAINER_ID);
      if (el && el.innerHTML.indexOf('Loading your order') > -1) {
        if (_renderScheduled) return;
        _renderScheduled = true;
        setTimeout(function() { _renderScheduled = false; render(); }, 50);
      }
    }).observe(parent, { childList: true, subtree: true });
  }

  function init() { render(); observe(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('cart:refresh', render);

})();


/**
 * Lucky Inger: design preselect from the client portal
 * Portal tiles link to /products/x?variant=ID&design=NAME.
 * This opens the order page on that design instead of the first one.
 * - dtf-order / screenprint-order: wraps window.dtfSelectDesign so the
 *   section's own init (which picks option 1) lands on the linked design.
 * - accessories / caps / beanie / bucket / straw: after the section init,
 *   sets the select value and fires its change handler.
 */
(function () {
  'use strict';
  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
  var want = (params.get('design') || '').trim();
  if (!want || !/\/products\//.test(window.location.pathname)) return;
  var wantKey = want.toLowerCase();

  function matchIndex(sel) {
    for (var i = 0; i < sel.options.length; i++) {
      var v = (sel.options[i].value || '').trim().toLowerCase();
      if (v && v === wantKey) return i;
    }
    return -1;
  }

  // DTF + screen print: section defines window.dtfSelectDesign inline
  var pending = true;
  function wrapDtf() {
    var orig = window.dtfSelectDesign;
    if (typeof orig !== 'function' || orig.__liWrapped) return !!orig;
    var wrapped = function (sel) {
      if (pending && sel && sel.id === 'dtf-design-select') {
        pending = false;
        var idx = matchIndex(sel);
        if (idx > 0) sel.selectedIndex = idx;
      }
      return orig.apply(this, arguments);
    };
    wrapped.__liWrapped = true;
    window.dtfSelectDesign = wrapped;
    return true;
  }
  if (!wrapDtf()) {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (wrapDtf() || tries > 40) clearInterval(t);
    }, 50);
  }

  // Other order sections: plain selects with change listeners
  var OTHER = ['bm-design-select', 'cap-design-select', 'bn-design-select', 'hw-design-select'];
  function applyOthers() {
    OTHER.forEach(function (id) {
      var sel = document.getElementById(id);
      if (!sel) return;
      var idx = matchIndex(sel);
      if (idx < 0 || sel.selectedIndex === idx) return;
      sel.selectedIndex = idx;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  function runOthers() {
    applyOthers();
    // second pass in case a section finishes its own init late
    setTimeout(applyOthers, 400);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runOthers);
  } else {
    runOthers();
  }
})();


/**
 * Lucky Inger: builder order email notification
 * When the cart submit button (#li-submit-btn) is clicked, a snapshot of the
 * order is posted to the lid-proofs Worker (/notify/order), which emails
 * NOTIFY_EMAIL via Resend.
 * - The cart is snapshotted ahead of time (on load and after every cart
 *   render) so nothing async has to happen at click time. The submit can
 *   clear the cart or navigate away immediately and the email still sends.
 * - Sent with navigator.sendBeacon (text/plain, no CORS preflight), falling
 *   back to fetch keepalive. Fire and forget: never blocks or breaks submit.
 * - Customer email / name come from the hidden <div id="li-cart-meta"> in
 *   the cart section (data-customer-email / data-customer-name).
 */
(function () {
  'use strict';
  var NOTIFY_URL = 'https://lid-proofs.rhiley-scholes123.workers.dev/notify/order';
  var SUBMIT_ID = 'li-submit-btn';
  var CONTAINER_ID = 'li-items-container';
  var DEDUPE_MS = 15000;

  var _snapshot = null;
  var _lastSent = 0;
  var _snapTimer = null;

  var MONEY_KEYS = ['Order total', 'Grand total', 'Line total', 'Total'];
  function money(props) {
    for (var i = 0; i < MONEY_KEYS.length; i++) {
      var raw = props[MONEY_KEYS[i]];
      if (raw === undefined || raw === null || raw === '') continue;
      var n = parseFloat(String(raw).replace(/[^0-9.\-]/g, ''));
      if (!isNaN(n)) return n;
    }
    return null;
  }

  function takeSnapshot() {
    _rawFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { _snapshot = cart; })
      .catch(function () {});
  }

  function scheduleSnapshot() {
    clearTimeout(_snapTimer);
    _snapTimer = setTimeout(takeSnapshot, 300);
  }

  function buildPayload() {
    var cart = _snapshot || { items: [] };
    var meta = liCartMeta();
    var ds = meta ? meta.dataset : {};
    var totalEl = document.getElementById('li-total');
    var lines = [];

    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      var clean = {};
      Object.keys(props).forEach(function (k) {
        if (k.charAt(0) === '_') return;
        if (props[k] === null || props[k] === undefined || props[k] === '') return;
        clean[k] = String(props[k]);
      });
      var m = money(props);
      lines.push({
        title: item.product_title || item.title || '',
        variant: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
        quantity: item.quantity || 0,
        total: m !== null ? m : (item.original_line_price || 0) / 100,
        url: item.url ? window.location.origin + item.url : '',
        properties: clean
      });
    });

    var liItems = window.LIOrder ? window.LIOrder.items() : [];
    liItems.forEach(function (it) {
      var sizes = it.sizes || {};
      var units = Object.keys(sizes).reduce(function (s, k) { return s + (parseInt(sizes[k]) || 0); }, 0);
      var clean = {};
      Object.keys(sizes).forEach(function (k) { if (parseInt(sizes[k])) clean[k] = String(sizes[k]); });
      if (it.printMethod) clean['Print method'] = String(it.printMethod);
      if (it.tier) clean['Tier'] = String(it.tier);
      lines.push({
        title: it.productTitle || '',
        variant: [it.design, it.colour].filter(Boolean).join(' - '),
        quantity: units,
        total: parseFloat(it.lineTotal) || 0,
        url: it.productUrl ? window.location.origin + it.productUrl : '',
        properties: clean
      });
    });

    return {
      type: 'builder_order',
      submittedAt: new Date().toISOString(),
      page: window.location.href,
      customerEmail: ds.customerEmail || '',
      customerName: ds.customerName || '',
      cartToken: cart.token || '',
      orderTotal: totalEl ? totalEl.textContent.trim() : '',
      lines: lines
    };
  }

  function send(payload) {
    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon) {
        var ok = navigator.sendBeacon(NOTIFY_URL, new Blob([body], { type: 'text/plain' }));
        if (ok) return;
      }
    } catch (e) {}
    try {
      _rawFetch(NOTIFY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: body,
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  function onClick(e) {
    var btn = e.target && e.target.closest ? e.target.closest('#' + SUBMIT_ID) : null;
    if (!btn || btn.disabled) return;
    // Draft order checkout: the Worker sends the staff email itself once the
    // draft exists, with the draft's link. Only the native flow beacons.
    var metaEl = liCartMeta();
    if (metaEl && metaEl.dataset.orderEndpoint) return;
    var now = Date.now();
    if (now - _lastSent < DEDUPE_MS) return;
    var payload = buildPayload();
    if (!payload.lines.length) return;
    _lastSent = now;
    send(payload);
  }

  function watchRenders() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container || !container.parentElement) return;
    new MutationObserver(scheduleSnapshot)
      .observe(container.parentElement, { childList: true, subtree: true });
  }

  function init() {
    if (!document.getElementById(CONTAINER_ID) && !document.getElementById(SUBMIT_ID)) return;
    takeSnapshot();
    watchRenders();
    document.addEventListener('click', onClick, true);
    window.addEventListener('li:order:updated', scheduleSnapshot);
    window.addEventListener('cart:refresh', scheduleSnapshot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Lucky Inger: cart submit (moved out of main-cart-items.liquid)
 * Section <script> blocks are wiped when cart.js re-renders the section, so
 * the handler lives here, delegated from document. Flow stays native:
 * saved order-builder lines -> /cart/add.js (quantity = total units),
 * order note -> /cart/update.js, then Shopify checkout.
 * Real Shopify errors show inline under the button instead of a generic alert.
 */
(function () {
  'use strict';
  var BTN_ID = 'li-submit-btn';

  function fmt(n) { return '$' + parseFloat(n || 0).toFixed(2); }

  function setBusy(btn, busy) {
    var spinner = document.getElementById('li-spinner');
    var label = btn.querySelector('.li-submit-label');
    btn.disabled = busy;
    if (spinner) spinner.style.display = busy ? 'inline-block' : 'none';
    if (label) {
      if (!label.dataset.idle) label.dataset.idle = label.textContent;
      label.textContent = busy ? 'Taking you to checkout' : label.dataset.idle;
    }
  }

  function showError(msg) {
    var el = document.getElementById('li-submit-error');
    if (!el) { alert(msg); return; }
    el.textContent = msg;
    el.hidden = !msg;
  }

  function buildLIItems() {
    var liItems = window.LIOrder ? window.LIOrder.items() : [];
    var out = [];
    liItems.forEach(function (item) {
      var qty = Object.values(item.sizes || {}).reduce(function (s, q) { return s + (parseInt(q) || 0); }, 0);
      if (!qty || !item.variantId) return;
      var props = {};
      props['Print method'] = item.printMethod || '';
      props['Design'] = item.design || '';
      if (item.colour)      props['Colour'] = item.colour;
      if (item.garmentType) props['Garment type'] = item.garmentType;
      Object.entries(item.sizes || {}).forEach(function (e) {
        if (parseInt(e[1]) > 0) props[e[0]] = String(e[1]);
      });
      props['Tier'] = item.tier || '';
      props['Total units'] = String(qty);
      props['Garments subtotal'] = fmt(item.garmentsSubtotal);
      if (item.setupFee)        props['Screen setup fee'] = fmt(item.setupFee);
      if (item.baggingFee)      props['Bagging fee'] = fmt(item.baggingFee);
      if (item.colourSurcharge) props['Colour surcharge'] = fmt(item.colourSurcharge);
      props['Line total'] = fmt(item.lineTotal);
      out.push({ id: item.variantId, quantity: qty, properties: props });
    });
    return out;
  }

  function post(url, body) {
    return _rawFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(liReadCartJson);
  }

  /* ── Draft order checkout (data-order-endpoint on #li-cart-meta) ─────────
     Shopify's checkout would charge every line at its 25+ list price. The
     cart's lines go to the lid-proofs Worker instead, which makes a draft
     order at the prices shown here and returns that draft's Shopify checkout
     link. The cart is then cleared and the customer finishes there.
     Remove the data attribute to fall back to the native /checkout flow. */
  var PENDING_KEY = 'li_pending_checkout';
  var TEST_KEY = 'li_test';

  /* Test orders: open the cart with ?li_test=1 and checkout is priced exactly
     like a real order, but no draft is made, no email goes out and the cart
     is kept. ?li_test=0 (or closing the tab) turns it off. */
  function testMode() {
    var on = false;
    try {
      var q = new URLSearchParams(window.location.search).get('li_test');
      if (q === '1') sessionStorage.setItem(TEST_KEY, '1');
      if (q === '0') sessionStorage.removeItem(TEST_KEY);
      on = sessionStorage.getItem(TEST_KEY) === '1';
    } catch (e) {
      on = /[?&]li_test=1(&|$)/.test(window.location.search);
    }
    return on;
  }

  function testBadge() {
    if (!testMode() || document.getElementById('li-test-badge')) return;
    var b = document.createElement('div');
    b.id = 'li-test-badge';
    b.textContent = 'Test mode: orders are not sent';
    b.style.cssText = 'position:fixed;left:12px;bottom:12px;z-index:9999;padding:8px 12px;border-radius:8px;background:#c0392b;color:#fff;font:600 13px/1.2 sans-serif;pointer-events:none';
    document.body.appendChild(b);
  }

  function showTestResult(data) {
    var box = document.getElementById('li-test-result');
    if (!box) {
      box = document.createElement('div');
      box.id = 'li-test-result';
      box.style.cssText = 'position:fixed;left:12px;right:12px;bottom:52px;z-index:9999;max-width:520px;max-height:60vh;overflow:auto;padding:14px 16px;border-radius:10px;background:#141414;color:#f3f3f3;border:1px solid #c0392b;font:14px/1.45 sans-serif;box-shadow:0 8px 30px rgba(0,0,0,.4)';
      document.body.appendChild(box);
    }
    box.textContent = '';
    function row(text, bold) {
      var d = document.createElement('div');
      d.textContent = text;
      if (bold) d.style.fontWeight = '700';
      box.appendChild(d);
    }
    row('Test order: nothing was sent', true);
    (data.lines || []).forEach(function (l) {
      row(l.quantity + ' x ' + l.name + ': ' + fmt(l.total));
    });
    row('Checkout total: ' + (data.total === null || data.total === undefined ? 'unknown' : fmt(data.total)), true);
    (data.priceCheck || []).forEach(function (f) { row('Price check: ' + f); });
    var close = document.createElement('button');
    close.type = 'button';
    close.textContent = 'Close';
    close.style.cssText = 'margin-top:10px;min-height:40px;padding:0 16px;border-radius:999px;border:1px solid rgba(243,243,243,.4);background:transparent;color:#f3f3f3;font:inherit;font-weight:700;cursor:pointer';
    close.addEventListener('click', function () { box.remove(); });
    box.appendChild(close);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', testBadge);
  else testBadge();

  function cartJson() {
    return _rawFetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(liReadCartJson);
  }

  function draftSubmit(btn, endpoint, note) {
    var ds = liCartMeta() ? liCartMeta().dataset : {};
    var isTest = testMode();
    var totalEl = document.getElementById('li-total');
    return cartJson()
      .then(function (cart) {
        var adds = buildLIItems();
        if (!adds.length && !(cart.items || []).length) throw new Error('Your order is empty.');
        return adds.length ? post('/cart/add.js', { items: adds }).then(cartJson) : cart;
      })
      .then(function (cart) {
        var items = cart.items || [];
        var live = 0;
        items.forEach(function (it) {
          var p = it.properties || {};
          var pm = p['Print method'] || '';
          if (pm === 'DTF' || pm === 'Digital') live += (window.liStatedUnits ? window.liStatedUnits(p) : null) || it.quantity || 0;
        });
        var lines = items.map(function (it) {
          var m = window.liLineMoney ? window.liLineMoney(it, live) : { total: null, unitHint: null, quote: false, units: it.quantity };
          return {
            variantId: it.variant_id,
            quantity: m.units || it.quantity,
            total: m.total,
            unitHint: m.unitHint,
            quote: !!m.quote,
            title: it.product_title || it.title || '',
            url: it.url ? window.location.origin + it.url : '',
            properties: it.properties || {}
          };
        });
        return _rawFetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            lines: lines,
            note: note,
            customerEmail: ds.customerEmail || '',
            customerName: ds.customerName || '',
            orderTotal: totalEl ? totalEl.textContent.trim() : '',
            cartToken: cart.token || '',
            page: window.location.href,
            test: isTest
          })
        });
      })
      .then(function (r) {
        return r.text().then(function (t) {
          var data = {};
          try { data = t ? JSON.parse(t) : {}; } catch (e) { data = {}; }
          if (!r.ok || !data.success || !(data.invoiceUrl || data.test)) {
            throw new Error(data.error || ('Checkout could not start (' + r.status + '). Please try again or email info@luckyinger.com.au.'));
          }
          return data;
        });
      })
      .then(function (data) {
        if (data.test) {
          // Test order: keep the cart, show what checkout would have charged.
          setBusy(btn, false);
          showTestResult(data);
          return;
        }
        if (isTest) throw new Error('Test mode is on but the order service did not run it as a test. Nothing was charged; check the Worker is the latest version.');
        try {
          localStorage.setItem(PENDING_KEY, JSON.stringify({ url: data.invoiceUrl, name: data.name || '', at: Date.now() }));
        } catch (e) {}
        // The order now lives in the draft. Empty the cart so it is not
        // submitted twice, then hand over to Shopify's checkout.
        return _rawFetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
          .catch(function () {})
          .then(function () {
            if (window.LIOrder) window.LIOrder.clear();
            try { sessionStorage.removeItem('li_cart_note'); } catch (e) {}
            window.location.href = data.invoiceUrl;
          });
      });
  }

  function submit(btn) {
    showError('');
    setBusy(btn, true);
    var noteEl = document.getElementById('li-note');
    var note = noteEl ? noteEl.value.trim() : '';
    var metaEl = liCartMeta();
    var endpoint = metaEl ? (metaEl.dataset.orderEndpoint || '') : '';
    if (endpoint) {
      draftSubmit(btn, endpoint, note).catch(function (err) {
        console.error('Submit error:', err);
        setBusy(btn, false);
        showError((err && err.message) || 'Something went wrong. Please try again.');
      });
      return;
    }

    _rawFetch('/cart.js')
      .then(liReadCartJson)
      .then(function (cart) {
        var adds = buildLIItems();
        if (!adds.length && !(cart.items || []).length) throw new Error('Your order is empty.');
        return adds.length ? post('/cart/add.js', { items: adds }) : null;
      })
      .then(function () {
        return note ? post('/cart/update.js', { note: note }) : null;
      })
      .then(function () {
        if (window.LIOrder) window.LIOrder.clear();
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('Submit error:', err);
        setBusy(btn, false);
        showError((err && err.message) || 'Something went wrong. Please try again.');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('#' + BTN_ID) : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    submit(btn);
  });
})();


/**
 * Lucky Inger: Lovable builder bridge (moved out of lucky-builder.liquid)
 * The section renders a wrapper with data- attributes and an empty iframe.
 * This block:
 *  - builds the iframe src (embed=1, logged-in customer, ?product= from the
 *    page URL) and sets it once, so the app loads a single time
 *  - forwards later ?product= changes to the app via postMessage
 *  - sizes the iframe (viewport fill, or auto-grow from lucky:resize)
 *  - handles lucky:add-to-cart: adds the brief lines natively, keeps the
 *    customer on the builder, and shows the popup with "Review order"
 *  - keeps the "Your order (n)" pill current, since the theme header is
 *    hidden on this page
 */
(function () {
  'use strict';

  function boot(wrap) {
    if (!wrap || wrap.dataset.liBooted) return;
    var iframe = wrap.querySelector('iframe[data-lucky-iframe]');
    var ds = wrap.dataset;
    if (!iframe || !ds.embedUrl) return;
    wrap.dataset.liBooted = '1';
    document.body.classList.add('li-on-builder');

    var allowedOrigin = '';
    try { allowedOrigin = new URL(ds.embedUrl).origin; } catch (e) { return; }

    function parentProduct() {
      try { return new URLSearchParams(window.location.search).get('product'); } catch (e) { return null; }
    }

    // ── iframe src ──
    try {
      var u = new URL(ds.embedUrl);
      u.searchParams.set('embed', '1');
      if (ds.customerEmail) u.searchParams.set('customer_email', ds.customerEmail);
      if (ds.customerName)  u.searchParams.set('customer_name', ds.customerName);
      if (ds.customerId)    u.searchParams.set('customer_id', ds.customerId);
      var p0 = parentProduct();
      if (p0) u.searchParams.set('product', p0);
      iframe.src = u.toString();
    } catch (e) { return; }

    // ── product forwarding ──
    var lastSent = parentProduct();
    function forwardProduct() {
      var p = parentProduct();
      if (!p || p === lastSent) return;
      lastSent = p;
      try { iframe.contentWindow.postMessage({ type: 'lucky:product', product: p }, allowedOrigin); } catch (e) {}
    }
    window.addEventListener('popstate', forwardProduct);
    ['pushState', 'replaceState'].forEach(function (fn) {
      var orig = history[fn];
      if (typeof orig !== 'function' || orig.__liWrapped) return;
      var wrapped = function () {
        var ret = orig.apply(this, arguments);
        forwardProduct();
        return ret;
      };
      wrapped.__liWrapped = true;
      history[fn] = wrapped;
    });

    // ── sizing ──
    var autoGrow = ds.autoGrow === 'true';
    var offD = parseInt(ds.offsetDesktop, 10) || 0;
    var offM = parseInt(ds.offsetMobile, 10) || 0;
    var minD = parseInt(ds.minDesktop, 10) || 800;
    var minM = parseInt(ds.minMobile, 10) || 700;
    function isMobile() { return window.innerWidth < 640; }
    var bar = wrap.querySelector('[data-lucky-bar]');
    function viewportFill() {
      var barH = bar ? bar.offsetHeight : 0;
      var h = Math.max(isMobile() ? minM : minD, window.innerHeight - barH - (isMobile() ? offM : offD));
      iframe.style.height = h + 'px';
    }
    if (autoGrow) {
      iframe.style.height = (isMobile() ? minM : minD) + 'px';
    } else {
      viewportFill();
      window.addEventListener('resize', viewportFill);
      window.addEventListener('orientationchange', viewportFill);
    }

    // ── order pill ──
    var pill = wrap.querySelector('[data-lucky-cart-pill]');
    var pillCount = pill ? pill.querySelector('[data-lucky-cart-count]') : null;
    function refreshPill() {
      if (!pill) return;
      var liCount = window.LIOrder ? window.LIOrder.count() : 0;
      _rawFetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var n = (cart.item_count || 0) + liCount;
          if (pillCount) pillCount.textContent = String(n);
          pill.hidden = n === 0;
        })
        .catch(function () {});
    }
    refreshPill();

    // ── messages from the app ──
    var briefVariantId = ds.briefVariantId || '';
    var adding = false;

    window.addEventListener('message', function (event) {
      if (event.origin !== allowedOrigin) return;
      var data = event.data || {};

      if (data.type === 'lucky:resize' && autoGrow && typeof data.height === 'number') {
        iframe.style.height = Math.max(isMobile() ? minM : minD, data.height) + 'px';
        return;
      }

      if (data.type !== 'lucky:add-to-cart' || !Array.isArray(data.lines) || adding) return;

      var items = data.lines.map(function (line) {
        return {
          id: Number(line.variantId || briefVariantId),
          quantity: parseInt(line.quantity, 10) || 1,
          properties: line.properties || {}
        };
      }).filter(function (item) { return !!item.id; });

      if (!items.length) {
        window.LIShowCartPopup && window.LIShowCartPopup({
          error: true,
          title: 'Your design is saved',
          sub: 'It could not be added to your order. Please contact us and we will sort it out.'
        });
        return;
      }

      adding = true;
      _rawFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(liReadCartJson)
        .then(function () {
          adding = false;
          var first = items[0].properties || {};
          var b = liBriefInfo(first);
          var total = items.reduce(function (s, it) {
            return s + (parseInt((it.properties || {})['Designs'], 10) || 1);
          }, 0);
          window.LIShowCartPopup && window.LIShowCartPopup({
            sticky: true,
            title: items.length === 1 ? b.title : total + ' designs added',
            sub: 'We will quote it after review. Add more designs or review your order.',
            imgSrc: b.img,
            stayLabel: 'Keep designing'
          });
          refreshPill();
          if (window.LIOrder) window.LIOrder.updateBadge();
        })
        .catch(function (err) {
          adding = false;
          console.error('Lucky Builder cart add failed', err);
          window.LIShowCartPopup && window.LIShowCartPopup({
            error: true,
            title: 'Your design is saved',
            sub: 'It could not be added to your order: ' + ((err && err.message) || 'cart error') + '. Please try again.'
          });
        });
    });
  }

  function init() {
    var wraps = document.querySelectorAll('[data-lucky-builder]');
    for (var i = 0; i < wraps.length; i++) boot(wraps[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();